import { render, staticRenderFns } from "./MainMediaWindow.vue?vue&type=template&id=85889d88&"
import script from "./MainMediaWindow.vue?vue&type=script&lang=js&"
export * from "./MainMediaWindow.vue?vue&type=script&lang=js&"
import style0 from "./MainMediaWindow.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports